module.exports = __webpack_public_path__ + "media/assets/certification_page/quote-open-30c6fc37f818a79019f32b01c869ddfccc4d32c07145e5dcb9ad3415e285ce26.svg";